import Axios from '@/plugins/Axios';
import { GetInsuranceCeilingResponse } from '@/types';
import { AxiosResponse } from 'axios';

const endpoint = '/insurance';

const insuranceApi = {
  getInsuranceCeiling: (partnerId: string, policyNumber: string) => {
    return Axios().get<GetInsuranceCeilingResponse>(
      `${endpoint}/${partnerId}/ceiling?insurance_policy_number=${policyNumber}`
    );
  },
};

export default insuranceApi;
